import {useMutation} from '@apollo/react-hooks';

import type {ReactionType} from 'nutshell-graphql-types';
import type {
    DeleteReaction as DeleteReactionMutation,
    DeleteReactionVariables as DeleteReactionMutationVariables,
    SessionUser,
} from 'nutshell-graphql-types';

import DELETE_REACTION from '../../../timeline/reactions/graphql/mutations/delete-reaction.graphql';

import ACTIVITY_MODAL_FRAGMENT from '../fragments/activity-for-modal-fragment.graphql';

export function useDeleteReaction(): (arg1: {
    changeLogId: string;
    reactionType: ReactionType;
    user: SessionUser;
    activityId: string;
}) => Promise<any> {
    const [deleteReaction] = useMutation<DeleteReactionMutation, DeleteReactionMutationVariables>(
        DELETE_REACTION
    );

    return (reactionInput: {
        changeLogId: string;
        reactionType: ReactionType;
        user: SessionUser;
        activityId: string;
    }) => {
        return deleteReaction({
            variables: {
                input: {
                    changeLogId: reactionInput.changeLogId,
                    userId: reactionInput.user.id,
                    type: reactionInput.reactionType,
                },
            },
            optimisticResponse: {
                reactionDelete: {
                    __typename: 'ReactionDeletePayload',
                    reactionDeleted: true,
                },
            },
            update: (proxy) => {
                const activityModalFragment = proxy.readFragment({
                    id: reactionInput.activityId,
                    fragmentName: 'ActivityModalFragment',
                    fragment: ACTIVITY_MODAL_FRAGMENT,
                });

                // @ts-expect-error
                if (activityModalFragment && activityModalFragment.comments) {
                    let updatedData: Record<string, any> = {};

                    // @ts-expect-error
                    const commentIndex = activityModalFragment.comments.edges.findIndex(
                        // @ts-expect-error
                        (comment) =>
                            comment.node.changeLogEntry &&
                            comment.node.changeLogEntry.id === reactionInput.changeLogId
                    );

                    if (commentIndex !== -1) {
                        // @ts-expect-error
                        const updatedComments = [...activityModalFragment.comments.edges];

                        // Remove the reaction
                        updatedComments[commentIndex].node.reactions = updatedComments[
                            commentIndex
                        ].node.reactions.filter(
                            // @ts-expect-error
                            (reaction) =>
                                reaction.reactionType !== reactionInput.reactionType ||
                                reaction.creatorUser.id !== reactionInput.user.id
                        );

                        updatedData = {
                            comments: {
                                // @ts-expect-error
                                totalCount: activityModalFragment.comments.totalCount,
                                edges: updatedComments,
                                __typename: 'CommentConnection',
                            },
                        };
                    }

                    proxy.writeFragment({
                        id: reactionInput.activityId,
                        fragment: ACTIVITY_MODAL_FRAGMENT,
                        fragmentName: 'ActivityModalFragment',
                        data: {
                            ...activityModalFragment,
                            __typename: 'Activity',
                            ...updatedData,
                        },
                    });
                }
            },
        });
    };
}
